import { ContentView } from '@/@diffrag/layout/ContentView'

export default function Translation() {
  return (
    <ContentView>
      <p className="text-lg font-bold">번역 Sheet</p>
      <a
        target="_blank"
        href="https://docs.google.com/spreadsheets/d/1NGvtdHqY0J90zFeAdXHBdGu4ZNlIhsLW9y_9-vUYWWc/edit?gid=0#gid=0"
        className="text-blue-500"
      >
        https://docs.google.com/spreadsheets/d/1NGvtdHqY0J90zFeAdXHBdGu4ZNlIhsLW9y_9-vUYWWc/edit?gid=0#gid=0
      </a>
    </ContentView>
  )
}
